<template>
  <div class="video-container">
    <div class="video">
      <div class="text-center center">
        <h1 class="error-subtitle red--text text--lighten-1">403</h1>
        <h4 class="text-uppercase error-subtitle white--text">
          SORRY, LICENSE IS INVALID.
        </h4>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Error",
  data: () => ({}),
  mounted() {
    // this.$store.dispatch("signOut");
  }
};
</script>

<style lang="scss">
.error-subtitle {
  color: #fff;
}
.video-container {
  position: relative;
  padding-bottom: 56.25%;
  background-color: rgb(0, 0, 0);
}

.video {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
.center {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
